const emojiQuiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "emoji-quiz",
    items: [
      { id: "q1", question: "🎤☔ ", answers: ["cantando na chuva"], image: null },
      { id: "q2", question: "🐍🐍✈️ ", answers: ["cobras em um avião"], image: null },
      { id: "q3", question: "👻🔫 ", answers: ["caça-fantasmas"], image: null },
      { id: "q4", question: "🐼👊 ", answers: ["kung fu panda"], image: null },
      { id: "q5", question: "🏃‍♂️📦🍫 ", answers: ["forrest gump"], image: null },
      { id: "q6", question: "🦁👑 ", answers: ["lion king"], image: null },
      { id: "q7", question: "🌊🦈 ", answers: ["jaws"], image: null },
      { id: "q8", question: "🕷️👨 ", answers: ["spiderman"], image: null },
      { id: "q9", question: "❄️🛳️ ", answers: ["titanic"], image: null },
      { id: "q10", question: "🤫🐑🐑 ", answers: ["silence of the lambs"], image: null },
      { id: "q11", question: "🪐🦍🦍 ", answers: ["planet of the apes"], image: null },
    ],
  },
  botId: "nualang.emoji-quiz.0.0.1",
  botName: "emoji_quiz",
  description: "emoji_quiz_desc",
  difficulty: "ALL",
  learnLang: "portuguese",
  name: "Conde Drácula",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwNi5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-smile?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Bem-vindo ao questionário do filme
Hospedado pelo Conde Drácula.

Você pode nomear os filmes representados pelo emoji?
Alguns retratam o título do filme, outros retratam a trama.

Diga "Olá" ao Conde Drácula para começar.`,
  voice: "Joey",
  versionQuestion: "Quantas perguntas você gostaria neste modelo?",
};

export default emojiQuiz;
